export const MIN_ITEMS_RULE_NAME = "min_items";
/**
 * Validates that an array has at least a minimum number of items.
 */
export const Validator = {
    name: MIN_ITEMS_RULE_NAME,
    errorMessage: `This array field must have at least : ${MIN_ITEMS_RULE_NAME} items.`,
    validate: (value, requirement) => Array.isArray(value) && value.length >= Number(requirement),
};
